// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ARwU","name":"styles_name__df6iv","phone":"styles_phone__1pqkG"};